export type AuthActionMode = "verifyEmail" | "resetPassword" | null;

/**
 * Firebase Auth action-linkek (?mode=...&oobCode=...) egységes feloldása.
 * oobCode nélkül egyik ág sem érvényes, ismeretlen mode-ra null.
 */
export function resolveAuthActionMode(
  mode: string | null,
  oobCode: string | null
): AuthActionMode {
  if (!oobCode) return null;
  if (mode === "verifyEmail") return "verifyEmail";
  if (mode === "resetPassword") return "resetPassword";
  return null;
}
